import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import type { Tag } from '#tags/types/tag.type';

import { Uri } from '#constants/uri';

/**
 * Retrieves the tags associated with a specific mailing list.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingListId - The unique identifier of the mailing list for which to fetch tags.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array of {@link Tag} objects.
 * @throws Throws an error if the HTTP request fails.
 */
export const getMailingListTags = async (instance: KyInstance, mailingListId: number) => {
  try {
    return await instance
      .get<OperationResultWithData<Tag[]>>(formatString(Uri.mailingList.getTags, mailingListId.toString()))
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
